export default __webpack_public_path__ + "static/media/support-icon.82512139.svg";